import { FC, RefAttributes, SVGProps } from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { DropdownMenuItemProps } from '@radix-ui/react-dropdown-menu';

import { JabraIcon } from '../JabraIcon/JabraIcon';

type UipMenuItemProps = DropdownMenuItemProps &
  RefAttributes<HTMLDivElement> & {
    icon: FC<SVGProps<SVGElement>>;
    label: string;
  };

export const UipMenuItem: FC<UipMenuItemProps> = ({ icon, label, ...rest }) => (
  <DropdownMenu.Item
    className="flex items-center gap-1 border-t border-gray-50 p-2.5 pl-8 text-[0.9rem] hover:bg-gray-50 focus-visible:outline-focus"
    {...rest}
  >
    <JabraIcon Icon={icon} />
    <span className="pl-1">{label}</span>
  </DropdownMenu.Item>
);
